module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/Fuzon-12d038f80034319d022824a7dbfd0b49.jpg";